<div class="connectivity-filter" *ngIf="form">
    <form [formGroup]="form" class="connectivity-filter__form">
      <div class="connectivity-filter__filter" *ngFor="let used of usedFilters; let uIdx = index">
        <button class="connectivity-filter__filter-remove  vox-btn vox-btn-secondary-grey"
          type="button"
          (click)="removeFilter(used)"
          [ngClass]="{'hidden': usedFilters.length === 1}"
          >
          <i class="connectivity-filter__filter-remove_symbol icon-small-remove"></i>
        </button>
        <div ngbDropdown class="connectivity-filter__filter-dropdown">
          <button class="vox-btn vox-btn-secondary connectivity-filter__filter-dropdown_btn"
            id="connectivity-filter-dropdown-{{uIdx}}"
            ngbDropdownToggle
            [disabled]="availableFilters.length < 1"
            >
            {{'connectivity.filters.' + used | translate}}
          </button>
          <div class="connectivity-filter__filter-dropdown_menu" ngbDropdownMenu aria-labelledby="connectivity-filter-dropdown">
            <button ngbDropdownItem class="connectivity-filter__filter-dropdown_item"
              type="button"
              *ngFor="let filter of availableFilters"
              (click)="updateFilters(filter, used)">
              {{'connectivity.filters.' + filter | translate}}
            </button>
          </div>
          <div class="connectivity-filter__filter-input" [ngSwitch]="used">
            <div *ngSwitchCase="'model'" class="connectivity-filter__filter-input vox-input-group vox-input-group_dense">
              <input
                class="vox-text-field"
                type="text"
                [placeholder]="'connectivity.filters.min-length-placeholder' | translate"
                formControlName="model"
                (keydown.enter)="emitFilters(); $event.preventDefault(); $event.stopPropagation();">
            </div>
            <div *ngSwitchCase="'brand'" class="connectivity-filter__filter-input vox-input-group vox-input-group_dense">
              <input
                class="vox-text-field"
                type="text"
                [placeholder]="'connectivity.filters.min-length-placeholder' | translate"
                formControlName="brand"
                (keydown.enter)="emitFilters(); $event.preventDefault(); $event.stopPropagation();">
            </div>
            <div class="connectivity-filter__filter-input vox-input-group vox-input-group_dense" *ngSwitchCase="'type'">
              <div ngbDropdown class="connectivity-filter__filter-dropdown">
                <button class="vox-btn vox-btn-secondary connectivity-filter__filter-dropdown_btn connectivity-filter__filter-dropdown_btn-type"
                  ngbDropdownToggle>
                  {{'connectivity.equipment-type.' + this.form.controls.type.value | lowercase | translate}}
                </button>
                <div class="connectivity-filter__filter-dropdown_menu" ngbDropdownMenu aria-labelledby="connectivity-filter-dropdown">
                  <button ngbDropdownItem class="connectivity-filter__filter-dropdown_item"
                    type="button"
                    *ngFor="let type of entryTypes"
                    (click)="onSelectEntryType(type)">
                    {{'connectivity.equipment-type.' + type | lowercase | translate}}
                  </button>
                </div>
              </div>
            </div>
            <div *ngSwitchCase="'created_at'" class="connectivity-filter__filter-input vox-input-group vox-input-group_dense">
              <gdp-date-picker formControlName="created_at" [placeholder]="'connectivity.filters.date-pricker-placeholder' | translate" class="connectivity-filter__filter-date"></gdp-date-picker>
            </div>
            <div *ngSwitchCase="'updated_at'" class="connectivity-filter__filter-input vox-input-group vox-input-group_dense">
              <gdp-date-picker formControlName="updated_at" [placeholder]="'connectivity.filters.date-pricker-placeholder' | translate" class="connectivity-filter__filter-date"></gdp-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="connectivity-filter__filter-add_container">
        <button class="vox-btn vox-btn-secondary connectivity-filter__filter-add"
          type="button"
          (click)="addFilter()"
          [disabled]="availableFilters.length < 1">
          <i class="connectivity-filter__filter-add_symbol icon-small-add">
          </i>
        </button>
        <button class="vox-btn vox-btn-secondary connectivity-filter__filter-apply"
          type="submit"
          (click)="emitFilters()"
          [disabled]="form.invalid">
          {{'connectivity.filters.apply-filters' | translate}}
        </button>
        <button class="ml-2 btn btn-link connectivity-filter__filter-clear"
          type="button"
          (click)="resetFilters()">
          {{'connectivity.filters.clear-filters' | translate}}
        </button>
      </div>
    </form>
</div>
